(function () {
  // Milestones must match snippets/cart-progress-bar.liquid
  const M1 = 3, M2 = 4, M3 = 5;

  function computeState(count) {
    if (count <= 0) return { state: 'empty', pct: 0, unlocked: 0, need: 0 };
    if (count < M1) return { state: 'to-m1', pct: (count / M1) * 100, unlocked: 0, need: M1 - count };
    if (count < M2) return { state: 'to-m2', pct: ((count - M1) / (M2 - M1)) * 100, unlocked: 1, need: M2 - count };
    if (count < M3) return { state: 'to-m3', pct: ((count - M2) / (M3 - M2)) * 100, unlocked: 2, need: M3 - count };
    return { state: 'done', pct: 100, unlocked: 3, need: 0 };
  }

  function renderBars(count) {
    const s = computeState(count);
    document.querySelectorAll('.auk-cart-progress').forEach((el) => {
      if (s.state === 'empty') {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      el.dataset.state = s.state;
      el.dataset.unlocked = String(s.unlocked);
      el.style.setProperty('--auk-pct', `${s.pct}%`);
      el.querySelectorAll('.auk-need').forEach((n) => { n.textContent = String(s.need); });
    });
  }

  // Fast path: read total from cart-page DOM (no network)
  function getCountFromCartPageDOM() {
    const inputs = document.querySelectorAll(
      'form#cart input.quantity__input, form#cart input[name="updates[]"]'
    );
    if (!inputs.length) return null;
    let total = 0;
    inputs.forEach((i) => {
      const v = parseInt(i.value, 10);
      if (!isNaN(v)) total += v;
    });
    return total;
  }

  async function fetchCartCount() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    const cart = await res.json();
    return Number(cart?.item_count || 0);
  }

  let timer = null;

  function instantFromDOMIfPossible() {
    const c = getCountFromCartPageDOM();
    if (c !== null) { renderBars(c); return true; }
    return false;
  }

  function instantFromEventDataIfPossible(eventData) {
    const cd = eventData && eventData.cartData;
    if (!cd) return false;
    const count = Number(cd.item_count);
    if (Number.isFinite(count)) { renderBars(count); return true; }
    return false;
  }

  function scheduleUpdate(opts) {
    opts = opts || {};
    if (instantFromEventDataIfPossible(opts.eventData)) return;
    if (instantFromDOMIfPossible()) return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(async () => {
      try { renderBars(await fetchCartCount()); } catch (e) { /* Liquid render is the source of truth on next paint */ }
    }, 50);
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => scheduleUpdate({ eventData }));
    }

    // Atelier-compatible cart events (no Dawn pubsub there)
    ['cart:updated', 'cart:refresh', 'cart:added', 'cart:change', 'on:cart:update', 'shopify:cart:updated'].forEach((evt) => {
      document.addEventListener(evt, () => scheduleUpdate());
    });

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;
      if (t.matches && t.matches('input[name="updates[]"], input.quantity__input, input[data-quantity-variant-id]')) {
        scheduleUpdate();
      }
    });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('button');
      if (!btn) return;
      if (btn.matches('.quantity__button') || btn.matches('button[name="plus"]') || btn.matches('button[name="minus"]')) {
        scheduleUpdate();
      }
    });

    instantFromDOMIfPossible();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
